import { goBack } from "connected-react-router";
import { isEmpty } from "lodash";
import Action from "pages/_components/Action";
import Button from "pages/_components/Button";
import FormattedDate from "pages/_components/FormattedDate";
import Loader from "pages/_components/Loader";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { DesktopButtons, MobileButtons, ResponsiveHeader } from "pages/_components/header";
import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { actions as creditBillsActions } from "reducers/creditBills";
import { billTabs, monedas } from "util/creditBills";
import { isIOS } from "react-device-detect";
import { getBillActions } from "../utils/actionMaker";
import CreditBillsAccordion from "./CreditBillsAccordion";
import FieldsDetailCreditBills from "./_components/FieldsDetailCreditBills";

const title = {
    [billTabs.EMITTED]: "credit.bills.emitted.detail.header",
    [billTabs.IN_TENURE]: "credit.bills.emitted.detail.header",
    [billTabs.RECEIVED]: "credit.bills.emitted.detail.header",
    [billTabs.TO_PAY]: "credit.bills.emitted.detail.header",
};

const DetailCreditBills = () => {
    const { fetching, creditBillsDetailList, creditBillList } = useSelector((state) => state.creditBills);
    const { id, type } = useParams();
    const arrayId = id?.split("-");
    const tabOption = type?.toUpperCase();
    const dispatch = useDispatch();
    let actionData;
    if (arrayId?.length > 0) {
        actionData = creditBillList.find(
            (object) =>
                object.facturaId.cuitEmisor === arrayId[0] &&
                object.facturaId.codTipoComprobante === Number(arrayId[1]) &&
                object.facturaId.puntoVenta === Number(arrayId[2]) &&
                object.facturaId.numeroComprobante === Number(arrayId[3]),
        );
    }
    const accordionLabels = ["indicadores", "trasmiciones"];
    const hasActionData = !isEmpty(actionData);

    const cuitEmisor = actionData?.facturaId?.cuitEmisor;
    const tipoComprobante = actionData?.facturaId?.codTipoComprobante;
    const numeroComprobante = actionData?.facturaId?.numeroComprobante;
    const puntoVenta = actionData?.facturaId?.puntoVenta;

    useEffect(() => {
        if (!hasActionData) {
            dispatch(goBack());
        }
    }, []);

    useEffect(() => {
        if (hasActionData) {
            dispatch(
                creditBillsActions.getCreditBillsDetail(cuitEmisor, tipoComprobante, numeroComprobante, puntoVenta),
            );
        }
    }, []);

    if (fetching || !hasActionData) {
        return <Loader />;
    }
    const formatedTrasmicions = creditBillsDetailList?.trasmiciones?.map((item) => ({
        trasnitter: (
            <div>
                {item.cuitTransmisor} <br /> {item.razonSocialTransmisor}
            </div>
        ),
        beneficiary: (
            <div>
                {item.cuitBeneficiario} <br /> {item.razonSocialBeneficiario}
            </div>
        ),
        date: <FormattedDate date={item.fechaTransmision} dateFormat="DD/MM/YYYY" />,
        type: item.tipoTransmision,
        motive: item.motivoTransmision,
        disown: item.motivoRepudio,
    }));

    const getAccordionData = () => ({
        indicadores: creditBillsDetailList,
        trasmiciones: formatedTrasmicions,
    });

    const billActionOptions = getBillActions(tabOption, actionData, dispatch).map((item) => ({
        text: item.label,
        func: item.onClick,
        textType: "I18N",
    }));

    const firstBillActionOption = billActionOptions[0];
    // eslint-disable-next-line prefer-const
    let othersBillActionOption = [];
    billActionOptions.forEach((element, index) => {
        if (index !== 0) {
            othersBillActionOption.push(element);
        }
    });

    return (
        <>
            <Notification scopeToShow="detail.redit.bills" />
            <ResponsiveHeader id={title[tabOption]}>
                {billActionOptions.length > 0 && (
                    <>
                        <DesktopButtons moreOptions={othersBillActionOption}>
                            {[
                                <Button
                                    className="btn-outline"
                                    onClick={firstBillActionOption.func}
                                    label={firstBillActionOption.text}
                                />,
                            ]}
                        </DesktopButtons>
                        <MobileButtons
                            image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                            {billActionOptions?.map((option) => (
                                <Action labelKey={option.text} handleClick={option.func} />
                            ))}
                        </MobileButtons>
                    </>
                )}
            </ResponsiveHeader>
            <MainContainer className="credit-bills__details" showLoader={fetching}>
                <div className="container">
                    <FieldsDetailCreditBills
                        estado={creditBillsDetailList?.estadoFactura.split("-")}
                        fechaEmision={creditBillsDetailList?.fechaEmision}
                        fechaVencimiento={creditBillsDetailList?.fechaVencimientoPago}
                        puntoVenta={creditBillsDetailList?.facturaId?.puntoVenta}
                        nroComprobante={creditBillsDetailList?.facturaId?.numeroComprobante}
                        tipoComprobante={creditBillsDetailList?.facturaId?.codTipoComprobante}
                        emisorCuit={creditBillsDetailList?.facturaId?.cuitEmisor}
                        emisor={creditBillsDetailList?.razonSocialEmisor}
                        deudorCuit={creditBillsDetailList?.cuitComprador}
                        deudor={creditBillsDetailList?.razonSocialComprador}
                        tenedorCuit={creditBillsDetailList?.cuitTenedor}
                        tenedor={creditBillsDetailList?.razonSocialTenedor}
                        debitoCbu={creditBillsDetailList?.cbuComprador || "--"}
                        creditoCbu={creditBillsDetailList?.cbuCredito || "--"}
                        currency={monedas[creditBillsDetailList?.moneda]}
                        saldo={creditBillsDetailList?.saldoAceptado}
                    />
                </div>
                <div className="container">
                    <CreditBillsAccordion labels={accordionLabels} data={getAccordionData()} />
                </div>
            </MainContainer>
        </>
    );
};

export default DetailCreditBills;
